import cx from "classnames";
import style from "./ReadMore.module.scss";
import { SliderCore } from "../../Slider/Slider";
import { ColorSection } from "../../../ColorContext";
import { ParallaxImage } from "../../ParallaxImage";
import { ScrollCard } from "../../Slider/SliderCard";
import { useState, useCallback, useEffect, useMemo } from "react";
import { getCards } from "../../../utils";
import { Preview } from "../Article";
import { Article } from "../../../routes";
import { Card } from "../../Card2/Card";
import { ReadMoreAnchor } from "../../../AnchorContext";

export const ReadMore = ({id} : {id: number}) => {
  const [cards, setCards] = useState<Preview[]>([]);
  const fetchCards = useCallback(async () => {
    const cards = await getCards();
    setCards(cards);
  }, []);
  useEffect(() => {
    fetchCards();
  }, [fetchCards]);


  const randomCards = useMemo(() => {
    return cards.filter(card => card.id !== id).sort(() => 0.5 - Math.random()).slice(0, 3);
  }, [id, cards]);
  return (
    <ReadMoreAnchor.Section>
    <ColorSection
      background={"white"}
      className={cx(style.readMore, "wrapper")}
    >
      <div className={style.title}>читайте также</div>

      <SliderCore items={3}>
        {randomCards.map((card, i) => {
          const cardprops = {
            content: <ParallaxImage src={"/" + card.preview + ".jpg"} alt="" />,
            title: card.title,
            description: card.description,
            titleAsHtml: true

          };
          return (
            <ScrollCard itemId={`${card.id}`} className={style["scroll-card"]}>
                <Article.Link id={card.id}>
                    <Card {...cardprops} className={style.cardFont} /> 
                </Article.Link>
              
            </ScrollCard>
          );
        })}
      </SliderCore>
    </ColorSection>
      </ReadMoreAnchor.Section>
  );
};
